import React from 'react';
import ReactDOM from 'react-dom';
// Component Style
import './styles/index.css';
//React router
import { BrowserRouter } from 'react-router-dom';
// Apollo Dependencies
import { ApolloClient } from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloLinkTimeout from 'apollo-link-timeout';

import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';

// ext Imports
import Home from './components/Home';

import registerServiceWorker from './registerServiceWorker';

const httpLink = createHttpLink({
  // uri: 'http://52.67.237.101/api/graphql',
  // uri: process.env.REACT_APP_URI,
  uri: process.env.REACT_APP_BACKEND_BASE_URL + "/api/graphql",

});

const timeoutLink = new ApolloLinkTimeout(300000);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token')
  const role = localStorage.getItem('current_user_role')
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : null,
      role: role ? `${role}` : null,
    }
  }
});

const client = new ApolloClient({
  link: authLink.concat(httpLink).concat(timeoutLink),
  cache: new InMemoryCache(),
  
});


ReactDOM.render(
  <MuiPickersUtilsProvider utils={MomentUtils}>
    <ApolloProvider client={client}>
      <BrowserRouter>
        <Home />
      </BrowserRouter>
    </ApolloProvider>
  </MuiPickersUtilsProvider>
  , document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// src/index.js